import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from '@pancakeswap/localization'
import { Button, ErrorState, NextLinkFromReactRouter } from '@pancakeswap/uikit'
import { useInfoRoute } from 'state/infoHub/hooks'
import { legacyInfoTarget } from './legacyRoute'

/** Unknown DEX in the URL (e.g. /info/uniswap): a clear state, never a blank page or a guessed DEX. */
export const InfoDexGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation()
  const { dex, isReady } = useInfoRoute()
  const router = useRouter()
  // An old /info/v2|v3 or PancakeSwap-tab link followed inside the app: send it where next.config would have (see legacyRoute.ts).
  const legacy = legacyInfoTarget(router.asPath)
  useEffect(() => {
    if (legacy) router.replace(legacy)
  }, [legacy, router])
  if (legacy || !isReady) return null
  if (!dex) {
    return (
      <ErrorState
        title={t('Unknown DEX')}
        description={t('Markets lists CADINUdex pools. Trades on every DEX Smart Swap uses are on the Smart Swap tab.')}
        tone="warning"
        action={
          <Button as={NextLinkFromReactRouter} to="/info/smart-swap" scale="sm">
            {t('Open Smart Swap')}
          </Button>
        }
      />
    )
  }
  return <>{children}</>
}
export default InfoDexGuard
